import { WidgetType } from '@/types';

/** 标注工具类型 */
export type AnnoHandlerType = WidgetType | 'spline3d' | 'series-point3d';
/** 辅助工具类型 */
export type AdditionHandlerType =
  | 'keypoint'
  | 'caliper'
  | 'caliper-h'
  | 'caliper-v'
  | 'crosshair'
  | 'pyramid'
  | 'freehand'
  | 'focus';

/**
 * 包含以下类型：
 * 1. select: 选择工具
 * 2. AnnoHandler: 标注类工具，负责标注物的创建、编辑
 * 3. AdditionHandler: 辅助类工具，负责辅助对象的创建
 * 4. reset: 重置当前的 handler (AnnoHandler + AdditionHandler)，如当前有编辑对象则放弃
 */
export type ToolType = 'select' | AnnoHandlerType | AdditionHandlerType | 'reset';

export type SegModeType = 'add' | 'cover' | 'remove';

export class Tool {
  static isAnno3DTool(tool: string): tool is AnnoHandlerType {
    return ['cuboid', 'poly3d', 'line3d', 'point3d', 'spline3d', 'series-point3d'].includes(tool);
  }

  static isAnno2DTool(tool: string): tool is AnnoHandlerType {
    return ['box2d', 'pscuboid', 'poly2d', 'line2d', 'point2d'].includes(tool);
  }

  /**
   * 是否是标注工具，需要放到 container 中。
   * 注意：此处 pyramid 虽然是辅助工具，但是需要放到 container 中，所以此处特殊加上判断
   */
  static isAnnoTool(tool: string): tool is AnnoHandlerType {
    return Tool.isAnno3DTool(tool) || Tool.isAnno2DTool(tool) || tool === 'pyramid' || tool === 'freehand' || tool === 'focus';
  }

  static isAdditionTool(tool: string): tool is AdditionHandlerType {
    return ['keypoint', 'caliper', 'caliper-h', 'caliper-v', 'crosshair'].includes(tool);
  }

  static isTool(tool: string): tool is ToolType {
    return tool === 'select' || Tool.isAnnoTool(tool) || Tool.isAdditionTool(tool);
  }

  static isAvailableTool(tool: string, toolControls: Partial<Record<ToolType, boolean>>): tool is ToolType {
    return Tool.isTool(tool) && toolControls[tool] !== false;
  }
}
